'use client';
import { stylePropertyPrefixes } from '../utilities/swan-style.utils.js';

const ROOT_CLASSNAMES = {
    base: 'swan',
    standardMode: `swan-${stylePropertyPrefixes.standardMode}`,
    darkMode: `swan-${stylePropertyPrefixes.darkMode}`,
    compactMode: `swan-${stylePropertyPrefixes.compactMode}`
};

export { ROOT_CLASSNAMES };
